import { LastConfigurationInfo } from '@avp/core'
import { createReducer } from 'typesafe-actions'
import {
    setLastConfigurationsAvailabilities,
    setLastConfigurations,
    setLastConfigurationsMerge,
    setLastConfigurationsLoadingDate,
} from '../actions/app/lastConfigurations.actions'

export const defaultState: LastConfigurationInfo = {
    lastConfigurations: [],
    lastConfigurationsAvailabilities: [],
    lastConfigurationsLoadingDate: null,
}

function mergeConfigurationsByDate(existing: LastConfigurationInfo['lastConfigurations'], toMerge: LastConfigurationInfo['lastConfigurations'],
): LastConfigurationInfo['lastConfigurations'] {
    const byDate = new Map(existing.map((lc) => [lc.date, lc]))
    for (const lc of toMerge) {
        byDate.set(lc.date, lc)
    }
    return Array.from(byDate.values())
}

const lastConfigurationsInfoReducer = createReducer(defaultState)
    .handleAction(setLastConfigurationsAvailabilities, (state, action) => ({
        ...state,
        lastConfigurationsAvailabilities: action.payload,
    }))
    .handleAction(setLastConfigurations, (state, action) => ({
        ...state,
        lastConfigurations: action.payload,
    }))
    .handleAction(setLastConfigurationsMerge, (state, action) => ({
        ...state,
        lastConfigurations: mergeConfigurationsByDate(state.lastConfigurations, action.payload),
    }))
    .handleAction(setLastConfigurationsLoadingDate, (state, action) => ({
        ...state,
        lastConfigurationsLoadingDate: action.payload,
    }))

export default lastConfigurationsInfoReducer
